import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Dropdown,
  Button,
} from "antd";
import {
  PlusOutlined,
  DownOutlined,
  AppstoreOutlined,
  SettingOutlined,
  BookOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";

import TodoList from "../CalenderAndTodo/TodoList";
import CalendarViewAndTransaction from "../CalenderAndTodo/CalendarViewAndTransaction";

import SelectAcademyYear from "../AcademyYearSelection/SelectAcademyYear";
import AddClass from "../../pages/Students/AddClass";
import SubjectFormModal from "../../SchoolDashApp/Class/Subjects/SubjectFormModal";
import DivisionFormModal from "../../SchoolDashApp/Division/DivisionFormModal";

import ProfileImageDashboard from "../ProfileImageDashboard";
import TotalStudentsCard from "./TotalStudentsCard";
import YearlySchoolFeeCount from "./YearlySchoolFeeCount";
import AcademicCount from "./AcademicCount";
import EmployeeCount from "./EmployeeCount";

const { Title, Text } = Typography;

const Overview = ({ theme }) => {
  const [openAddClass, setOpenAddClass] = useState(false);
  const [openSubjectModal, setOpenSubjectModal] = useState(false);
  const [openDivisionModal, setOpenDivisionModal] = useState(false);

  const triggerAcademicCountUpdate = () => {
    window.dispatchEvent(new Event("academicCountUpdated"));
  };

  const addMenu = {
    items: [
      {
        key: "class",
        label: "Add Grade Class",
        icon: <AppstoreOutlined />,
      },
      {
        key: "subject",
        label: "Add Subject",
        icon: <BookOutlined />,
      },
      {
        key: "division",
        label: "Add Division",
        icon: <ApartmentOutlined />,
      },
    ],
    onClick: ({ key }) => {
      if (key === "class") {
        setOpenAddClass(true);
      }

      if (key === "subject") {
        setOpenSubjectModal(true);
      }

      if (key === "division") {
        setOpenDivisionModal(true);
      }
    },
  };

  return (
    <div
      className="overview-page"
      style={{
        width: "100%",
        maxWidth: 1800,
        margin: "0 auto",
        padding: "0 2px",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 7 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Card
          bordered={false}
          className="overview-main-card"
          style={{
            width: "100%",
            marginBottom: 16,
            borderRadius: 18,
            overflow: "hidden",
            background: theme.card,
            border: `1px solid ${theme.border}`,
            boxShadow: "0 8px 26px rgba(6,42,75,.055)",
          }}
          styles={{
            body: {
              padding: 0,
            },
          }}
        >
          <div className="overview-header">
            <div className="overview-header-decoration" />

            <div className="overview-header-left">
              <div className="overview-profile">
                <ProfileImageDashboard
                  theme={theme}
                  overview
                />
              </div>

              <div className="overview-header-divider" />

              <div className="overview-heading">
                <Text
                  className="overview-eyebrow"
                  style={{
                    color: theme.secondary,
                  }}
                >
                  Institutional Overview
                </Text>

                <Title
                  level={3}
                  className="overview-title"
                  style={{
                    color: theme.text,
                  }}
                >
                  Admin Dashboard
                </Title>

            
              </div>
            </div>

            <div className="overview-header-actions">
              <div className="overview-year-wrapper">
                <SelectAcademyYear theme={theme} />
              </div>

              <Dropdown
                menu={addMenu}
                placement="bottomRight"
                trigger={["click"]}
              >
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  className="overview-add-button"
                >
                  <span className="overview-add-label">Add</span>
                  <DownOutlined className="overview-add-arrow" />
                </Button>
              </Dropdown>
            </div>
          </div>
        </Card>

        <Row
          gutter={[14, 14]}
          style={{
            width: "100%",
            margin: 0,
          }}
        >
          <Col
            xs={24}
            sm={12}
            xl={6}
            style={{
              paddingLeft: 7,
              paddingRight: 7,
            }}
          >
            <TotalStudentsCard theme={theme} />
          </Col>

          <Col
            xs={24}
            sm={12}
            xl={6}
            style={{
              paddingLeft: 7,
              paddingRight: 7,
            }}
          >
            <YearlySchoolFeeCount theme={theme} />
          </Col>

          <Col
            xs={24}
            sm={12}
            xl={6}
            style={{
              paddingLeft: 7,
              paddingRight: 7,
            }}
          >
            <AcademicCount theme={theme} />
          </Col>

          <Col
            xs={24}
            sm={12}
            xl={6}
            style={{
              paddingLeft: 7,
              paddingRight: 7,
            }}
          >
            <EmployeeCount theme={theme} />
          </Col>
        </Row>

        <Row
          gutter={[14, 14]}
          style={{
            marginTop: 14,
            marginLeft: 0,
            marginRight: 0,
          }}
        >
          <Col xs={24} xl={11}>
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.08,
                duration: 0.3,
              }}
              style={{
                height: "100%",
              }}
            >
              <Card
                bordered={false}
                style={{
                  height: "100%",
                  minHeight: 350,
                  borderRadius: 18,
                  background: theme.card,
                  border: `1px solid ${theme.border}`,
                  boxShadow: "0 8px 26px rgba(6,42,75,.055)",
                  overflow: "hidden",
                }}
                styles={{
                  body: {
                    padding: 0,
                  },
                }}
              >
                <div
                  className="overview-section-header"
                  style={{
                    borderBottom: `1px solid ${theme.border}`,
                  }}
                >
                  <div
                    className="overview-section-title-area"
                    style={{
                      minWidth: 0,
                    }}
                  >
                    <Text
                      style={{
                        display: "block",
                        color: theme.secondary,
                        fontSize: 10,
                        lineHeight: 1.1,
                        fontWeight: 700,
                        letterSpacing: ".8px",
                        textTransform: "uppercase",
                      }}
                    >
                      Daily Workspace
                    </Text>

                    <Title
                      level={4}
                      style={{
                        margin: "3px 0 0",
                        color: theme.text,
                        fontSize: 18,
                        lineHeight: 1.2,
                        fontWeight: 800,
                      }}
                    >
                      Tasks & Priorities
                    </Title>
                  </div>

                  <div
                    className="overview-section-icon"
                    style={{
                      background:
                        theme.mode === "dark"
                          ? "rgba(192,117,13,.12)"
                          : "#FCF8F1",
                      color: "#C0750D",
                    }}
                  >
                    <SettingOutlined />
                  </div>
                </div>

                <div
                  style={{
                    padding: 12,
                  }}
                >
                  <TodoList />
                </div>
              </Card>
            </motion.div>
          </Col>

          <Col xs={24} xl={13}>
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.12,
                duration: 0.3,
              }}
              style={{
                height: "100%",
              }}
            >
              <Card
                bordered={false}
                style={{
                  height: "100%",
                  minHeight: 350,
                  borderRadius: 18,
                  background: theme.card,
                  border: `1px solid ${theme.border}`,
                  boxShadow: "0 8px 26px rgba(6,42,75,.055)",
                  overflow: "hidden",
                }}
                styles={{
                  body: {
                    padding: 0,
                  },
                }}
              >
                <div
                  className="overview-section-header"
                  style={{
                    borderBottom: `1px solid ${theme.border}`,
                  }}
                >
                  <div
                    className="overview-section-title-area"
                    style={{
                      minWidth: 0,
                    }}
                  >
                    <Text
                      style={{
                        display: "block",
                        color: theme.secondary,
                        fontSize: 10,
                        lineHeight: 1.1,
                        fontWeight: 700,
                        letterSpacing: ".8px",
                        textTransform: "uppercase",
                      }}
                    >
                      Institutional Activity
                    </Text>

                    <Title
                      level={4}
                      style={{
                        margin: "3px 0 0",
                        color: theme.text,
                        fontSize: 18,
                        lineHeight: 1.2,
                        fontWeight: 800,
                      }}
                    >
                      Calendar & Transactions
                    </Title>
                  </div>

                  <div
                    className="overview-section-icon"
                    style={{
                      background:
                        theme.mode === "dark"
                          ? "rgba(15,109,171,.12)"
                          : "#F3F8FC",
                      color: "#0F6DAB",
                    }}
                  >
                    <BookOutlined />
                  </div>
                </div>

                <div
                  style={{
                    padding: 12,
                  }}
                >
                  <CalendarViewAndTransaction />
                </div>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </motion.div>

      <AddClass
        open={openAddClass}
        handleClose={() => setOpenAddClass(false)}
        onClassCreated={triggerAcademicCountUpdate}
      />

      <SubjectFormModal
        open={openSubjectModal}
        handleClose={() => setOpenSubjectModal(false)}
        onSubjectCreated={triggerAcademicCountUpdate}
      />

      <DivisionFormModal
        open={openDivisionModal}
        handleClose={() => setOpenDivisionModal(false)}
        onDivisionCreated={triggerAcademicCountUpdate}
      />

      <style>
        {`
          .overview-header {
            position: relative;
            width: 100%;
            min-height: 82px;
            padding: 12px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 18px;
            box-sizing: border-box;
            overflow: hidden;
          }

          .overview-header-decoration {
            position: absolute;
            width: 150px;
            height: 150px;
            border-radius: 50%;
            right: -60px;
            top: -80px;
            background: rgba(192,117,13,.045);
            pointer-events: none;
          }

          .overview-header-left {
            position: relative;
            z-index: 1;
            min-width: 0;
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            gap: 14px;
          }

          .overview-profile {
            flex: 0 0 auto;
            min-width: 0;
            display: flex;
            align-items: center;
          }

          .overview-header-divider {
            width: 1px;
            height: 46px;
            flex: 0 0 1px;
            background: ${theme.border};
          }

          .overview-heading {
            min-width: 0;
            flex: 1 1 auto;
            overflow: hidden;
          }

          .overview-eyebrow {
            display: block;
            margin-bottom: 2px;
            font-size: 10px;
            line-height: 1.1;
            font-weight: 700;
            letter-spacing: 1px;
            text-transform: uppercase;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .overview-title {
            margin: 0 !important;
            font-size: 21px !important;
            line-height: 1.15 !important;
            font-weight: 800 !important;
            letter-spacing: -.3px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .overview-description {
            display: block;
            max-width: 500px;
            margin-top: 2px;
            font-size: 11px;
            line-height: 1.25;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .overview-header-actions {
            position: relative;
            z-index: 3;
            flex: 0 0 auto;
            min-width: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 8px;

            /* Only change: move Academic Year + Add slightly lower */
            transform: translateY(10px);
          }

          .overview-year-wrapper {
            min-width: 0;
            flex: 0 1 auto;
          }

          .overview-year-wrapper > * {
            max-width: 100%;
          }

          .overview-add-button {
            height: 38px !important;
            min-width: 76px !important;
            flex: 0 0 auto !important;
            padding: 0 12px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 5px !important;
            font-weight: 750 !important;
            background: #C0750D !important;
            border-color: #C0750D !important;
            box-shadow: 0 5px 15px rgba(192,117,13,.16) !important;
            white-space: nowrap !important;
          }

          .overview-add-button:hover,
          .overview-add-button:focus {
            background: #A86208 !important;
            border-color: #A86208 !important;
          }

          .overview-add-arrow {
            font-size: 9px;
          }

          .overview-section-header {
            padding: 15px 17px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
          }

          .overview-section-icon {
            width: 36px;
            height: 36px;
            flex: 0 0 36px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          @media (max-width: 1200px) {
            .overview-header {
              gap: 12px;
            }

            .overview-header-left {
              gap: 11px;
            }

            .overview-heading {
              max-width: 390px;
            }

            .overview-title {
              font-size: 20px !important;
            }

            .overview-header-actions {
              transform: translateY(8px);
            }
          }

          @media (max-width: 1000px) {
            .overview-header {
              align-items: flex-start;
              flex-direction: column;
              gap: 12px;
              padding: 14px;
            }

            .overview-header-left {
              width: 100%;
              flex: 0 0 auto;
            }

            .overview-heading {
              max-width: none;
            }

            .overview-header-actions {
              width: 100%;
              flex: 0 0 auto;
              justify-content: flex-end;
              transform: translateY(4px);
            }

            .overview-year-wrapper {
              flex: 0 1 260px;
            }
          }

          @media (max-width: 600px) {
            .overview-header {
              min-height: auto;
              padding: 13px 12px;
              gap: 12px;
            }

            .overview-header-left {
              width: 100%;
              gap: 9px;
              align-items: flex-start;
            }

            .overview-header-divider {
              height: 42px;
              margin-top: 1px;
            }

            .overview-heading {
              width: 100%;
              min-width: 0;
            }

            .overview-eyebrow {
              font-size: 9px;
              letter-spacing: .75px;
            }

            .overview-title {
              font-size: 18px !important;
              line-height: 1.15 !important;
            }

            .overview-description {
              max-width: 100%;
              font-size: 10px;
              line-height: 1.3;
            }

            .overview-header-actions {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: stretch;
              gap: 8px;
              transform: translateY(2px);
            }

            .overview-year-wrapper {
              min-width: 0;
              flex: 1 1 auto;
              width: auto;
            }

            .overview-year-wrapper > * {
              width: 100%;
              max-width: 100%;
            }

            .overview-add-button {
              min-width: 76px !important;
              width: 76px !important;
              height: 38px !important;
              padding: 0 10px !important;
            }

            .overview-add-label {
              display: inline;
            }

            .overview-section-header {
              padding: 14px;
            }
          }

          @media (max-width: 460px) {
            .overview-header {
              padding: 12px 10px;
              gap: 10px;
            }

            .overview-header-left {
              gap: 8px;
            }

            .overview-header-divider {
              display: none;
            }

            .overview-description {
              display: none;
            }

            .overview-title {
              font-size: 17px !important;
            }

            .overview-header-actions {
              gap: 7px;
              transform: translateY(1px);
            }

            .overview-add-button {
              min-width: 72px !important;
              width: 72px !important;
              padding: 0 8px !important;
            }

            .overview-add-arrow {
              font-size: 8px;
            }
          }

          @media (max-width: 360px) {
            .overview-header {
              padding: 10px 9px;
            }

            .overview-title {
              font-size: 16px !important;
            }

            .overview-eyebrow {
              font-size: 8px;
            }

            .overview-header-actions {
              gap: 6px;
              transform: translateY(1px);
            }

            .overview-add-button {
              min-width: 68px !important;
              width: 68px !important;
              padding: 0 7px !important;
            }

            .overview-add-label {
              font-size: 12px;
            }
          }

          @media (max-width: 320px) {
            .overview-header-actions {
              flex-wrap: nowrap;
              transform: translateY(0);
            }

            .overview-add-button {
              min-width: 64px !important;
              width: 64px !important;
            }

            .overview-add-label {
              display: none;
            }

            .overview-add-arrow {
              display: none;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Overview;

